import { Comment } from "./Comment";
import { User, newUser } from "./User";
import { Tag } from "./Tag";

export type Question = {
    id: number;
    title: string;
    body: string;
    author: User;
    createdAt: string;
    updatedAt: string;
    votes: number;
    userVote: number;
    answersCount: number;
    acceptedAnswer: number;
    views: number;
    tags: Tag[];
    comments: Comment[];
};

export function newQuestion(author = newUser(), title = "", body = "", tags: Tag[] = []): Question {
    const question: Question = {
        id: -1,
        title: title,
        body: body,
        author: author,
        createdAt: "2020-01-01",
        updatedAt: "2020-01-01",
        votes: 0,
        userVote: 0,
        answersCount: 0,
        acceptedAnswer: -1,
        views: 0,
        tags: tags,
        comments: [],
    };

    return question;
}
